"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uniqueActionTypes = _interopRequireDefault(require("crm_data/flux/uniqueActionTypes"));

var OnboardingActionTypes = (0, _uniqueActionTypes.default)({
  REGISTER_ONBOARDING: 'REGISTER_ONBOARDING',
  START_ONBOARDING_TOUR: 'START_ONBOARDING_TOUR',
  END_ONBOARDING_TOUR: 'END_ONBOARDING_TOUR',
  SET_ONBOARDING_TOUR_STEP: 'SET_ONBOARDING_TOUR_STEP'
});
var _default = OnboardingActionTypes;
exports.default = _default;
module.exports = exports.default;